import { render, staticRenderFns } from "./public-foot-audio.vue?vue&type=template&id=fa1dab38&scoped=true&"
import script from "./public-foot-audio.vue?vue&type=script&lang=js&"
export * from "./public-foot-audio.vue?vue&type=script&lang=js&"
import style0 from "./public-foot-audio.vue?vue&type=style&index=0&id=fa1dab38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1dab38",
  null
  
)

export default component.exports